// StepDefinition.js
import { useState, useContext, useEffect } from "react";
import { Box, Tooltip } from "@mui/material";
import CommonAccordion from "../../custom-components/CommonAccordion";
import CommonDownload from "../../custom-components/CommonDownload";
// import { TestCaseFlowDataContext } from '../../main-pages/TestAutomationPage';
import { useNavigate } from "react-router-dom";
import CodeEditor from "./CodeEditor";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import {
  mavenProjectWithToolCalling,
} from "../../../services/webServices";
import SaveAltRoundedIcon from "@mui/icons-material/SaveAltRounded";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import SuccessPopup from "./SuccessPopup"; // Import SuccessPopup
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import CommonCopy from "../../custom-components/CommonCopy";
import MessagePopup from "../../popup-components/MessagePopup";


const StepDefinition = (props) => {
  const navigate = useNavigate();

  const [downloadOpen, setDownloadOpen] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [processedStepDefinition, setProcessedStepDefinition] = useState("");
  const [testEnvironmentData, setTestEnvironmentData] = useState(
    props.testEnvironmentData || {}
  );

  const featureFiles = props.featureFile;
  const pageClass = props.pageClass;
  const [stepDefinitionData, setstepDefinitionData] = useState(
    props.stepDefinition
  );

  const { setLoadingState } = useContext(LoadingModalContext);
  const [liked, setLiked] = useState(false);
  const [disliked, setDisliked] = useState(false);

  const [openSuccessPopup, setOpenSuccessPopup] = useState(false); // State to control the SuccessPopup
  const [activeThumb, setActiveThumb] = useState(null);
  const [zipBlob, setZipBlob] = useState(null); // ⬅ store zip here

  const defaultExpanded = props.stepDefinition !== "";

  useEffect(() => {
    setstepDefinitionData(props.stepDefinition);
  }, [props.stepDefinition]);

  const handleDownloadClick = () => {
    setDownloadOpen(true);
  };

  const handleCloseDownload = () => {
    setDownloadOpen(false);
  };

  const generateVariablesJSON = (data) => {
    const jsonOutput = {
      TestSettings: {
        Environment: "QA",
        BaseUrl: data.url || "",
        Browser: data.browser || "",
        TimeoutInSeconds: "",
        Headless: false,
      },
    };

    return JSON.stringify(jsonOutput, null, 2); // nicely formatted JSON
  };

  const handleMavenProject = async () => {
    let fake;
    const startProgress = (setProgress) => {
      let progress = 0;
      let stop = false;
      let finalMessageShown = false;

      const interval = setInterval(() => {
        if (stop) return;

        progress += 0.001;
        if (progress >= 98 && !finalMessageShown) {
          finalMessageShown = true;
          setLoadingState((prev) => ({
            ...prev,
            message: "Almost done! Fetching your output",
          }));
        }

        if (progress >= 98) progress = 98;

        setProgress((prev) => ({
          ...prev,
          progress: Math.max(prev.progress, Math.floor(progress)),
        }));
      }, 200);

      return {
        stop: () => {
          stop = true;
          clearInterval(interval);
        },
        completeTo100: async () => {
          stop = true;
          clearInterval(interval);

          // Rush to 100%
          setProgress((prev) => ({
            ...prev,
            progress: 100,
          }));
          await new Promise((res) => setTimeout(res, 500));
        },
      };
    };

    const finishTo100AndClose = async () => {
      await fake.completeTo100();
      setLoadingState({ open: false, message: "", progress: null });
    };
    // Initial message
    setLoadingState({
      open: true,
      message: "Generating your Project",
      progress: 0,
    });

    fake = startProgress(setLoadingState);

    const pageClassData = pageClass;
    const featureFileGenerated = featureFiles;

    try {
      const response = await mavenProjectWithToolCalling(
        { featureFileGenerated, pageClassData, stepDefinitionData },
        props.framework
      );

      let {
        pomXmlContent,
        testngSuiteFile,
        testRunnerClassContent,
        configProperties,
        extentProperties,
        loggingConfig,
        supportClasses,
        readmeFile,
      } = response.data;

      const zip = new JSZip();
      if (
        props.framework === "selenium-java" ||
        props.framework === "playwright-java"
      ) {
        // Append the profile content after </build> in pomXmlContent
        if (response.data.testProfileContent) {
          const profileContent = response.data.testProfileContent;
          pomXmlContent = pomXmlContent.replace(
            /<\/build>/,
            `</build>\n${profileContent}`
          );
        }

        if (props.framework === "selenium-java") {
          const utilsClassContent = `package utils;

import org.apache.commons.io.FileUtils;
import org.openqa.selenium.*;
import org.openqa.selenium.NoSuchElementException;
import org.openqa.selenium.interactions.Actions;
import org.openqa.selenium.support.ui.*;

import java.io.File;
import java.io.IOException;
import java.text.SimpleDateFormat;
import java.time.Duration;
import java.util.*;


public class Utils {
    private static final long DEFAULT_TIMEOUT = 15;
    private static final long DEFAULT_POLLING = 1;
    private static final long IMPLICIT_TIME = 5;

    private WebDriver driver;
    private Actions action;
    private JavascriptExecutor js;

    public Utils(WebDriver driver) {
        this.driver = driver;
        this.action = new Actions(driver);
        this.js = (JavascriptExecutor) driver;
    }

    // ---------- Fluent Wait Core ----------
    public WebElement fluentWaitForElement(By locator, long timeout, long polling) {
        Wait<WebDriver> wait = new FluentWait<>(driver)
                .withTimeout(Duration.ofSeconds(timeout))
                .pollingEvery(Duration.ofSeconds(polling))
                .ignoring(NoSuchElementException.class)
                .ignoring(StaleElementReferenceException.class)
                .ignoring(ElementClickInterceptedException.class);
        return wait.until(ExpectedConditions.visibilityOfElementLocated(locator));
    }

    public List<WebElement> fluentWaitForElements(By locator, long timeout, long polling) {
        Wait<WebDriver> wait = new FluentWait<>(driver)
                .withTimeout(Duration.ofSeconds(timeout))
                .pollingEvery(Duration.ofSeconds(polling))
                .ignoring(NoSuchElementException.class)
                .ignoring(StaleElementReferenceException.class);
        return wait.until(ExpectedConditions.visibilityOfAllElementsLocatedBy(locator));
    }

    public WebElement getWebElement(By locator) {
        return fluentWaitForElement(locator, DEFAULT_TIMEOUT, DEFAULT_POLLING);
    }

    public List<WebElement> getMatchingWebElements(By locator) {
        try {
            return fluentWaitForElements(locator, DEFAULT_TIMEOUT, DEFAULT_POLLING);
        } catch (Exception e) {
            return new ArrayList<>();
        }
    }

    public List<WebElement> findElements(By locator) {
        return getMatchingWebElements(locator);
    }

    // ---------- Element Interaction ----------
    public void clickElement(By locator) {
        getWebElement(locator).click();
    }

    public void clickAndWaitElement(By locator, int timer) {
        getWebElement(locator).click();
    }

    public void doubleClick(By locator) {
        action.doubleClick(getWebElement(locator)).perform();
    }

    public void jsClickElement(By locator) {
        js.executeScript("arguments[0].click();", getWebElement(locator));
    }

    public void inputText(By locator, String sText) {
        getWebElement(locator).sendKeys(sText);
    }

    public void clearAndInputText(By locator, String sText) {
        WebElement ele = getWebElement(locator);
        ele.clear();
        ele.sendKeys(sText);
    }

    public void clearInput(By locator, String sText) {
        getWebElement(locator).clear();
    }

    public void scrollToElement(By locator) {
        js.executeScript("arguments[0].scrollIntoView(true);", getWebElement(locator));
    }

    public void hoverOverElement(By locator) {
        action.moveToElement(getWebElement(locator)).perform();
    }

    public String getText(By locator) {
        try {
            return getWebElement(locator).getText();
        } catch (Exception e) {
            return null;
        }
    }

    public String getAttribute(By locator, String sAttrKey) {
        return getWebElement(locator).getAttribute(sAttrKey);
    }

    public boolean isElementPresent(By locator) {
        try {
            getWebElement(locator);
            return true;
        } catch (Exception e) {
            return false;
        }
    }

    public boolean isAttributePresent(By locator, String sAttrKey) {
        try {
            return getWebElement(locator).getAttribute(sAttrKey) != null;
        } catch (Exception e) {
            return false;
        }
    }

    public boolean isElementVisible(By locator, long iTimeInSeconds) {
        try {
            waitUntilElementIsVisible(locator, iTimeInSeconds);
            return true;
        } catch (Exception e) {
            return false;
        }
    }

    public boolean isElementVisible(By locator) {
        return isElementVisible(locator, DEFAULT_TIMEOUT);
    }

    public boolean isAlertVisible() {
        try {
            waitForAlert(DEFAULT_TIMEOUT);
            return true;
        } catch (NoAlertPresentException e) {
            return false;
        }
    }

    // ---------- Waits ----------
    public void waitUntilElementIsVisible(By locator, long iTimeout) {
        new WebDriverWait(driver, Duration.ofSeconds(iTimeout))
                .until(ExpectedConditions.visibilityOfElementLocated(locator));
    }

    public void waitUntilElementIsInVisible(By locator, long iTimeout) {
        new WebDriverWait(driver, Duration.ofSeconds(iTimeout))
                .until(ExpectedConditions.invisibilityOfElementLocated(locator));
    }

    public void waitForAlert(long iTimeout) {
        new WebDriverWait(driver, Duration.ofSeconds(iTimeout))
                .until(ExpectedConditions.alertIsPresent());
    }

    public void waitUntilElementIsClickable(By locator, long iTimeout) {
        new WebDriverWait(driver, Duration.ofSeconds(iTimeout))
                .until(ExpectedConditions.elementToBeClickable(locator));
    }

    public void waitTillClickableAndClick(By locator, long iTimeout) {
        for (int i = 0; i < iTimeout; i++) {
            try {
                clickElement(locator);
                break;
            } catch (Exception ignored) {}
        }
    }

    public void waitForFrameAndSwitch(By locator, long iTimeout) {
        new WebDriverWait(driver, Duration.ofSeconds(iTimeout))
                .until(ExpectedConditions.frameToBeAvailableAndSwitchToIt(locator));
    }

    // ---------- Frame & Window ----------
    public void switchToFrame(By locator) {
        driver.switchTo().frame(getWebElement(locator));
    }

    public void switchToDefault() {
        driver.switchTo().defaultContent();
    }

    public void openNewWindowWithURL(String sURL) {
        js.executeScript("window.open()");
        ArrayList<String> tabs = new ArrayList<>(driver.getWindowHandles());
        driver.switchTo().window(tabs.get(1));
        driver.get(sURL);
    }

    public void closeCurrentWindow() {
        ArrayList<String> tabs = new ArrayList<>(driver.getWindowHandles());
        driver.close();
        if (!tabs.isEmpty()) {
            driver.switchTo().window(tabs.get(0));
        }
    }

    public void switchToWindow(String windowHandle) {
        driver.switchTo().window(windowHandle);
    }

    public void switchToNewWindow() {
        String mainWindow = driver.getWindowHandle();
        Set<String> handles = driver.getWindowHandles();
        for (String handle : handles) {
            if (!handle.equals(mainWindow)) {
                driver.switchTo().window(handle);
                return;
            }
        }
        throw new NoSuchWindowException("No new window found to switch to.");
    }

    // ---------- Screenshot ----------
    public String takeScreenshotAndSave(String screenshotName) {
        File scrFile = takeScreenShot();
        String destFile = screenshotName + ".png";
        String filePath = File.separator + destFile;
        try {
            FileUtils.copyFile(scrFile, new File(filePath));
        } catch (IOException e) {
            throw new RuntimeException("Screenshot not saved properly: " + e.getMessage());
        }
        return filePath;
    }

    public String takeScreenshotAndSave() {
        return takeScreenshotAndSave("Screenshot_" + getCurrentTime());
    }

    private File takeScreenShot() {
        return ((TakesScreenshot) driver).getScreenshotAs(OutputType.FILE);
    }

    // ---------- Alerts ----------
    public void acceptAlert() {
        driver.switchTo().alert().accept();
    }

    public void dismissAlert() {
        driver.switchTo().alert().dismiss();
    }

    // ---------- Other ----------
    public void refresh() {
        driver.navigate().refresh();
    }

    public void highLightElement(WebElement element) {
        js.executeScript("arguments[0].style.border='3px solid red'", element);
    }

    public static String getCurrentTime() {
        return new SimpleDateFormat("yyyy.MM.dd.HH.mm.ss").format(new java.util.Date());
    }
}
`;
          zip.file("src/main/java/utils/Utils.java", utilsClassContent);
        }

        // Add the modified `pom.xml` content
        zip.file("pom.xml", pomXmlContent);

        // Add the testng.xml file
        if (!!testngSuiteFile) {
          zip.file("testngSuite.xml", testngSuiteFile);
        }

        // Add the readme file
        if (readmeFile) {
          zip.file("README.md", readmeFile);
        }

        if (testRunnerClassContent)
          zip.file(
            "src/test/java/tests/TestRunner.java",
            testRunnerClassContent
          );

        const generateVariablesFile = (data) => {
          return `
# Configuration file for Selenium tests

${data.url ? `url = ${data.url}` : ""}
${data.browser ? `browser = ${data.browser}` : ""}
${data.os ? `os = ${data.os}` : ""}
${data.username ? `username = ${data.username}` : ""}
${data.password ? `password = ${data.password}` : ""}
`.trim();
        };

        zip.file(
          "src/test/resources/config.properties",
          generateVariablesFile(testEnvironmentData)
        );

        if (!!extentProperties) {
          zip.file("src/test/resources/extent.properties", extentProperties);
        }

        if (loggingConfig)
          zip.file("src/main/resources/log4j.properties", loggingConfig);

        // Add support classes
        if (Array.isArray(supportClasses)) {
          supportClasses.forEach((supportClass) => {
            if (supportClass.content && supportClass.name) {
              zip.file(
                `src/test/java/${supportClass.name}`,
                supportClass.content
              );
            }
          });
        }

        zip.file(
          "src/test/resources/features/featureFiles.feature",
          featureFileGenerated
        );
        // zip.file(
        //   "src/test/java/pages/PageClasses.java",
        //   pageClassData.pageClassGenerated
        // );

        pageClassData.forEach((pageClass) => {
          const classname = Object.keys(pageClass)[0];
          const classcontent = pageClass[classname];

          const filepath = `src/test/java/pages/${classname}.java`;
          zip.file(filepath, classcontent);
        });
        if (typeof stepDefinitionData === "string") {
          zip.file(
            "src/test/java/gluecode/StepDefinitions.java",
            stepDefinitionData
          );
        } else if (Array.isArray(stepDefinitionData)) {
          stepDefinitionData.forEach((stepdef) => {
            const classname = Object.keys(stepdef)[0];
            const classcontent = stepdef[classname];

            const filepath = `src/test/java/gluecode/${classname}.java`;
            zip.file(filepath, classcontent);
          });
        }
        // zip.file(
        //   "src/test/java/gluecode/StepDefinitions.java",
        //   stepDefinitionData.stepDefinitionGenerated
        // );

        // zip.file(
        //   `src/test/resources/features/featureFiles.feature`,
        //    featureFileGenerated);
      } else if (props.framework === "c-sharp") {
        const configFolder = zip.folder("Selenium_CSharp_Project/Config");
        configFolder.file(
          "RunSettings.json",
          generateVariablesJSON(testEnvironmentData)
        );

        const featureFolder = zip.folder("Selenium_CSharp_Project/Features");
        featureFolder.file("FeatureFile.feature", featureFileGenerated);

        const stepDefinitionFolder = zip.folder(
          "Selenium_CSharp_Project/StepDefinitions"
        );
        if (typeof stepDefinitionData === "string") {
          stepDefinitionFolder.file("StepDefinition.cs", stepDefinitionData);
        } else if (Array.isArray(stepDefinitionData)) {
          stepDefinitionData.forEach((stepdef) => {
            const classname = Object.keys(stepdef)[0];
            const classcontent = stepdef[classname];

            const filepath = `Selenium_CSharp_Project/StepDefinitions/${classname}.cs`;
            zip.file(filepath, classcontent);
          });
        }

        //  stepDefinitionFolder.file("StepDefinition.cs", stepDefinitionData.stepDefinitionGenerated);

        const pageClassFolder = zip.folder(
          "Selenium_CSharp_Project/PageClasses"
        );
        // pageClassFolder.file("PageClass.cs", pageClassData.pageClassGenerated);

        pageClassData.forEach((pageClass) => {
          const classname = Object.keys(pageClass)[0];
          const classcontent = pageClass[classname];

          const filepath = `Selenium_CSharp_Project/PageClasses/${classname}.cs`;
          zip.file(filepath, classcontent);
        });

        const librariesFolder = zip.folder("Selenium_CSharp_Project/Libraries");
        librariesFolder.file("Constants.cs", "");

        const utilsFolder = zip.folder("Selenium_CSharp_Project/Utils");
        utilsFolder.file("Utils.cs", "");

        const prestineFilesFolder = zip.folder(
          "Selenium_CSharp_Project/PrestineFiles"
        );

        const hooksFolder = zip.folder("Selenium_CSharp_Project/Hooks");
        hooksFolder.file("Hooks.cs", "");
      } else if (props.framework === "playwright-c-sharp") {
        const configFolder = zip.folder("PlayWright_CSharp_Project/Config");
        configFolder.file(
          "RunSettings.json",
          generateVariablesJSON(testEnvironmentData)
        );

        const featureFolder = zip.folder("PlayWright_CSharp_Project/Features");
        featureFolder.file("FeatureFile.feature", featureFileGenerated);

        const stepDefinitionFolder = zip.folder(
          "PlayWright_CSharp_Project/StepDefinitions"
        );
        console.log("stepDefinitionData", stepDefinitionData);
        console.log("stepDefinitionData type", typeof stepDefinitionData);
        if (typeof stepDefinitionData === "string") {
          stepDefinitionFolder.file("StepDefinition.cs", stepDefinitionData);
        } else if (Array.isArray(stepDefinitionData)) {
          stepDefinitionData.forEach((stepdef) => {
            const classname = Object.keys(stepdef)[0];
            const classcontent = stepdef[classname];

            const filepath = `PlayWright_CSharp_Project/StepDefinitions/${classname}.cs`;
            zip.file(filepath, classcontent);
          });
        }

        //stepDefinitionFolder.file("StepDefinition.cs", stepDefinitionData.stepDefinitionGenerated);

        const pageClassFolder = zip.folder(
          "PlayWright_CSharp_Project/PageClasses"
        );
        pageClassData.forEach((pageClass) => {
          const classname = Object.keys(pageClass)[0];
          const classcontent = pageClass[classname];

          const filepath = `PlayWright_CSharp_Project/PageClasses/${classname}.cs`;
          zip.file(filepath, classcontent);
        });

        //pageClassFolder.file("PageClass.cs", pageClassData.pageClassGenerated);

        const librariesFolder = zip.folder(
          "PlayWright_CSharp_Project/Libraries"
        );
        librariesFolder.file("Constants.cs", "");

        const utilsFolder = zip.folder("PlayWright_CSharp_Project/Utils");
        utilsFolder.file("Utils.cs", "");

        const prestineFilesFolder = zip.folder(
          "PlayWright_CSharp_Project/PrestineFiles"
        );

        const hooksFolder = zip.folder("PlayWright_CSharp_Project/Hooks");
        hooksFolder.file("Hooks.cs", "");
      }

      //const blob = await zip.generateAsync({ type: "blob" });
      zip.generateAsync({ type: "blob" }).then((content) => {
        setZipBlob(content); // store in local state
        saveAs(
          content,
          props.framework === "selenium-java" ||
            props.framework === "playwright-java"
            ? "mavenProject.zip"
            : props.framework === "c-sharp" ||
              props.framework === "playwright-c-sharp"
            ? "specflowProject.zip"
            : ""
        );
      });

      // saveAs(
      //   blob,
      //   props.framework === "selenium-java" || props.framework === "playwright-java"
      //     ? "mavenProject.zip"
      //     : props.framework === "c-sharp" || props.framework === "playwright-c-sharp"
      //       ? "specflowProject.zip"
      //       : ""
      // );

      // After the project is downloaded, show the success popup
      setTimeout(setOpenSuccessPopup(true), 3000);
    } catch (error) {
      const errorMsg =
        error?.response?.data?.Error || "An error occurred. Please try again.";
      setPopupMessage(errorMsg);
      setPopupOpen(true);
      setLoadingState({ open: false, message: "", progress: null });
    } finally {
      setLoadingState({ open: false, message: "", progress: null });
    }
  };

  const handleGitHubProject = async () => {
    console.log("Navigating to GitHub with zipBlob:", zipBlob);
    
    if (!zipBlob) {
      console.error("ZIP file not generated yet.");
      return;
    }
    navigate(`/dashboard/test-automation/newproject-gitcredentials`, {
      state: {
        framework: props.framework,
        projectType: props.projectType,
        zipFile: zipBlob,
      },
    });
  };

  const buttonsgroupJava = [
   {
      label: "Download",
      variant: "text",
      onClick: handleDownloadClick,
      startIcon: <SaveAltRoundedIcon />,
    },
    ...(props.nextButton || [])
  ]

  // const buttonsgroupJava = [
  //   {
  //     label: "Download",
  //     variant: "text",
  //     onClick: handleDownloadClick,
  //     startIcon: <SaveAltRoundedIcon />,
  //   },
  //   (!props.nextButton ? {
  //     label:
  //       props.framework === "selenium-java"
  //         ? "Generate Project"
  //         : props.framework === "c-sharp"
  //         ? "Generate Project"
  //         : props.framework === "playwright-c-sharp"
  //         ? "Generate Project"
  //         : props.framework === "playwright-java"
  //         ? "Generate Project"
  //         : "",

  //     variant: "contained",
  //     startIcon: <GenerateButton />,
  //     sx: { marginLeft: "auto", marginRight: 1 },
  //     onClick: handleMavenProject,
  //   } : props.nextButton),
  //   {
  //     label: "Push to GitHub",
  //     variant: "contained",
  //     startIcon: <GenerateButton />,
  //     sx: { marginRight: 1, whiteSpace: "nowrap" },
  //     onClick: handleGitHubProject,
  //     disabled: !zipBlob, // Disable if zipBlob is not available
  //   },
  // ];



  const handleThumbClick = (thumbType) => {
    // Toggle thumbs based on the thumbType (like or dislike)
    setActiveThumb((prev) => (prev === thumbType ? null : thumbType));
  };

  useEffect(() => {
    const processed = (() => {
      try {
        if (Array.isArray(stepDefinitionData)) {
          return stepDefinitionData
            .map((obj) => Object.values(obj).join(" "))
            .join("\n");
        }
        const parsed = JSON.parse(stepDefinitionData);
        if (Array.isArray(parsed)) {
          return parsed.map((obj) => Object.values(obj).join(" ")).join("\n");
        }
        return stepDefinitionData;
      } catch (e) {
        return stepDefinitionData;
      }
    })();

    setProcessedStepDefinition(processed);
  }, [stepDefinitionData]);

  return (
    <>
      <Box>
        <CommonAccordion
          summary={"Step Definition"}
          details={
            <Box>
              <CodeEditor
                codeContent={(() => {
                  try {
                    // If it's an array, join values
                    if (Array.isArray(stepDefinitionData)) {
                      return stepDefinitionData
                        .map((obj) => Object.values(obj).join(" "))
                        .join("\n");
                    }

                    // Try to parse string (if it was stored as JSON)
                    const parsed = JSON.parse(stepDefinitionData);
                    if (Array.isArray(parsed)) {
                      return parsed
                        .map((obj) => Object.values(obj).join(" "))
                        .join("\n");
                    }

                    // If not parsable or not an array, return as-is
                    return stepDefinitionData;
                  } catch (e) {
                    return stepDefinitionData; // fallback in case of error
                  }
                })()}
                setCodeContent={setstepDefinitionData}
              />

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mb: 2,
                  marginTop: 2,
                }}
              >
                <Tooltip title="Like" arrow>
                  <Box
                    onClick={() => handleThumbClick("like")}
                    sx={{
                      cursor: "pointer",
                      marginRight: 2, // Margin between the buttons
                      "&:hover": {
                        color: "#49A3FF", // Change color on hover
                      },
                    }}
                  >
                    {activeThumb === "like" ? (
                      <ThumbUpIcon sx={{ fontSize: "24px" }} /> // Filled thumbs up when clicked
                    ) : (
                      <ThumbUpOutlinedIcon sx={{ fontSize: "24px" }} /> // Outlined thumbs up by default
                    )}
                  </Box>
                </Tooltip>

                {/* Thumbs Down Button with Tooltip */}
                <Tooltip title="Dislike" arrow>
                  <Box
                    onClick={() => handleThumbClick("dislike")}
                    sx={{
                      cursor: "pointer",
                      marginRight: 2, // Margin between the buttons
                      "&:hover": {
                        color: "#FF4842", // Change color on hover
                      },
                    }}
                  >
                    {activeThumb === "dislike" ? (
                      <ThumbDownIcon sx={{ fontSize: "24px" }} /> // Filled thumbs down when clicked
                    ) : (
                      <ThumbDownOutlinedIcon sx={{ fontSize: "24px" }} /> // Outlined thumbs down by default
                    )}
                  </Box>
                </Tooltip>
                <CommonCopy contentToCopy={processedStepDefinition} />
              </Box>
            </Box>
          }
          buttons={buttonsgroupJava}
          fullScreenMode={true}
          type={"output"}
          defaultExpanded={defaultExpanded}
        ></CommonAccordion>
      </Box>
      <MessagePopup
        modalOpen={popupOpen}
        okayHandler={() => setPopupOpen(false)}
        message={popupMessage}
      />

      <CommonDownload
        open={downloadOpen}
        onClose={handleCloseDownload}
        serviceResponse={[
          {
            heading: "Step Definition",
            type: "text",
            data: processedStepDefinition,
          },
        ]}
        serviceName="Step Definition"
        wordData={[
          {
            heading: "Step Definition",
            type: "text",
            data: processedStepDefinition,
          },
        ]}
        documents={["docx"]}
      />

      <SuccessPopup
        open={openSuccessPopup}
        handleClose={() => setOpenSuccessPopup(false)}
        // text={"Maven"}
        text={
          props.framework === "selenium-java" ||
          props.framework === "playwright-java"
            ? "Maven"
            : props.framework === "c-sharp"
            ? "SpecFlow"
            : props.framework === "playwright-c-sharp"
            ? "SpecFlow"
            : ""
        }
      />
    </>
  );
};

export default StepDefinition;
